var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import helper from '../../../ts/helper';
import getAddress from '../../../ts/getAddress';
var Register = /** @class */ (function (_super) {
    __extends(Register, _super);
    function Register() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.account_name = '';
        _this.email = '';
        _this.company_code = '';
        _this.hire_year = 2018;
        _this.hire_month = 4;
        _this.hire_day = 1;
        _this.password = '';
        _this.background_img = './static/img/background.png';
        _this.address = '';
        _this.private_key = '';
        _this.public_key = '';
        _this.password_confirmation = '';
        _this.get = new getAddress();
        return _this;
    }
    Register.prototype.mounted = function () { };
    Register.prototype.signupSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request_1, url, account_name, email, company_code, hire_year, hire_month, hire_day, public_key, private_key, password, request_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$route.params.public_key || !this.$route.params.address || !this.$route.params.private_key) {
                            this.address = this.get.address;
                            this.private_key = this.get.privateKey;
                            this.public_key = this.get.publicKey;
                            console.log(this.address);
                            console.log(this.address);
                            console.log(this.private_key);
                            console.log(this.public_key);
                        }
                        else {
                            this.address = this.$route.params.address;
                            this.private_key = this.$route.params.private_key;
                            this.public_key = this.$route.params.public_key;
                        }
                        if (!(this.account_name.length != 0)) return [3 /*break*/, 8];
                        if (!(this.email.length != 0)) return [3 /*break*/, 6];
                        if (!this.checkDate(this.hire_year, this.hire_month, this.hire_day)) return [3 /*break*/, 4];
                        if (!(this.password == this.password_confirmation && this.password.length >= 6)) return [3 /*break*/, 2];
                        return [4 /*yield*/, new XMLHttpRequest()];
                    case 1:
                        request_1 = _a.sent();
                        url = this.$data.helper.path + "users/sign_up/" + this.address;
                        account_name = "?account_name=" + this.account_name;
                        email = "&email=" + this.email;
                        company_code = "&company_code=" + this.company_code;
                        hire_year = "&hire_year=" + this.hire_year;
                        hire_month = "&hire_month=" + this.hire_month;
                        hire_day = "&hire_day=" + this.hire_day;
                        public_key = "&public_key=" + this.public_key;
                        private_key = "&private_key=" + this.private_key;
                        password = "&password=" + this.password;
                        request_url = url + account_name + email + company_code + hire_year + hire_month + hire_day + public_key + private_key + password;
                        console.log(request_url);
                        request_1.open('GET', request_url);
                        request_1.onreadystatechange = function () {
                            if (request_1.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_1.status != 200) {
                                // 失敗
                                console.log('失敗');
                                var result = request_1.responseText;
                                alert("登録に失敗しました。" + result);
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                var result = request_1.responseText;
                                alert(result);
                                location.reload();
                            }
                        };
                        request_1.send(null);
                        console.log('tapsignupSend' + account_name + email);
                        this.$data.signup_modal = false;
                        return [3 /*break*/, 3];
                    case 2:
                        alert("パスワードが不正です。");
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        alert("入社日が不正です。");
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        alert("メールアドレスを入力してください。");
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        alert("アカウント名を入力してください。");
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.checkDate = function (y, m, d) {
        var today = new Date();
        var hire_date_last_day = new Date(this.hire_year, this.hire_month - 1, 0);
        var hire_date = new Date(this.hire_year, this.hire_month - 1, this.hire_day, 0, 0, 0, 0);
        console.log(hire_date);
        if (m < 1 || m > 12) {
            return false;
        }
        else if (hire_date_last_day.getDate() < d || d < 0) {
            return false;
        }
        else if (hire_date > today) {
            return false;
        }
        return true;
    };
    Register = __decorate([
        Component({
            name: 'register',
            data: function () { return ({
                title: "アカウント登録",
                helper: new helper(),
            }); },
            props: ['version'],
        })
    ], Register);
    return Register;
}(Vue));
export default Register;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/Register.vue
// module id = 272
// module chunks = 1